<template>
  <div class="landwell">
      <div class="nav">
            <div class="nav-area">
                <div class="return-label" @click="returnHome">
                    <img src="/photo/icon/LOGO-正钻.png" alt="首页">
                </div>
                <div class="slogan">
                    <img src="/photo/icon/slogan.png" alt="标题">
                </div>
                <div class="label">
                    <img src="/photo/icon/正品标签.png" alt="正品标签">
                </div>
            </div>
        </div>
        <div class="tooltip">
            <img src="/photo/icon/提示.png" alt="提示">
            <span class="desc1">{{tooltip.desc1}}</span>
            <span class="desc2">{{tooltip.desc2}}</span>
            <span>{{tooltip.desc3}}</span>
        </div>
        <div class="data-list">
            <div class="download">
                <!-- 产品软件列表 -->
                <div
                    class="list"
                    v-for="item in softwareList"
                    :key="item.Id">
                    <!-- 名称 -->
                    <div class="name">
                        {{item.name}}
                    </div>
                    <!-- 产品图标 -->
                    <img class="img" :src="item.img" :alt="1"/>
                    <!-- 按键组 -->
                    <div class="button-btn">
                        <!-- 软件下载 -->
                        <a
                            class="software"
                            :href="item.software"
                            target="_black">
                            {{item.softwareButton}}
                        </a>
                        <!-- 说明书下载 -->
                        <a
                            class="manual"
                            v-if="item.manual"
                            :href="item.manual"
                            target="_black">
                            {{item.desc}}
                        </a>
                        <!-- 视频教程链接 -->
                        <a
                            class="video-manual"
                            v-if="item.videoManual"
                            :href="item.videoManual"
                            target="_black">
                            {{item.desc}}
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="application-place">
            <div class="place-list">
                <div class="list"
                    v-for="(item, index) in areaList"
                    :key="index">
                    <img :src="item.img" alt="应用场所">
                </div>
            </div>
        </div>
        <div class="process-move"></div>
        <img class="process-quiet" src="/photo/icon/软件操作流程.jpg" alt="软件流程">
  </div>
</template>

<script>
export default {
    name: 'Landwell',
    data () {
        return {
            // 时间戳
            timeStamp: 0,
            // 控制导航页面的显示-隐藏
            homeIcon: 'show',
            // 提示信息
            tooltip: "",
            // 产品软件列表数组
            softwareList: [],
            // 应用场所列表
            areaList: []
        }
    },
    created () {
        // 获取时间戳
        this.getTimeStamp()
        this.request()
    },
    mounted () {
        this.changeNav()
        window.addEventListener('resize', this.resize)
    },
    methods: {
        // 获取时间戳
        getTimeStamp () {
            this.timeStamp = new Date().getTime()
            // console.log(this.timeStamp)
        },
        // 获取静态json文件数据
        request () {
            this.$http.get('/mock/landwell.json', {
                params: {
                    timeStamp: this.timeStamp
                }
            })
                .then((res) => {
                    this.softwareList = res.data.data.softwareInfo
                    this.tooltip = res.data.data.tooltip
                })
            this.$http.get('/mock/area.json')
                .then((res) => {
                    this.areaList = res.data.data.list
                })
        },
        // 下载软件
        download (val) {
            window.open(`http://www.xundean.com:8887/download/${val}.zip`)
        },
        // 下载说明书
        manualDownload (val) {
            window.open(`http://www.xundean.com:8887/download/${val}`)
        },
        resize () {
            this.changeNav()
        },
        // 返回brand页面
        returnHome () {
            this.homeIcon = 'hide'
            this.$router.push({ name: 'Brand' })
        },
        // 通过屏幕的宽度控制导航条的显示
        changeNav () {
            var screenwidth = document.documentElement.clientWidth
            if (screenwidth < 900) {
                this.homeIcon = 'hide'
            } else {
                this.homeIcon = 'show'
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.landwell {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 auto;
    width: 1150px;
    background: #f4f5f5;
    .nav {
        margin-top: 5px;
        width: 100%;
        height: 175px;
        background: #fff;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        .nav-area {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-content: center;
            margin: 0 10px;
            .return-label, .slogan, .labei {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
            }
            .return-label {
                cursor: pointer;
                img {
                    width: auto;
                    height: 100px;
                }
            }
            .slogan {
                img {
                    width: auto;
                    height: 100px;
                }
            }
            .label {
                img {
                    height: 175px;
                    width: 175px;
                }
            }
        }
    }
    .tooltip {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        height: 50px;
        background: #d6ebff;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        img {
            margin-left: 10px;
            width: 40px;
            height: 40px;
        }
        span {
            font-weight: 450;
            letter-spacing: 1px;
        }
        .desc1 {
            margin-left: 10px;
        }
        .desc2 {
            color: #ff0000;
        }
    }
    .data-list {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        width: 1040px;
        background: #f4f5f5;
        .download {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            margin-top: 20px;
            margin-left: -10px;
            .list {
                display: flex;
                flex-direction: column;
                margin-left: 10px;
                width: 200px;
                height: 300px;
                .name {
                    width: 200px;
                    height: 30px;
                    line-height: 30px;
                    font-size: 20px;
                    letter-spacing: 0.5px;
                    text-align: center;
                    color: #fff;
                    background: #409eff;
                    border-top-left-radius: 3px;
                    border-top-right-radius: 3px;
                }
                .img {
                    margin: 0;
                    width: 200px;
                    height: 200px;
                    vertical-align: top;
                }
                .button-btn {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-around;
                    align-items: center;
                    width: 200px;
                    height: 50px;
                    background: #d6ebff;
                    border-bottom-left-radius: 3px;
                    border-bottom-right-radius: 3px;
                    .software, .manual, .video-manual {
                        width: 80px;
                        height: 25px;
                        line-height: 25px;
                        text-align: center;
                        font-size: 14px;
                        font-weight: bold;
                        color: #409eff;
                        background: #fff;
                        border-radius: 10px;
                        text-decoration: none;
                        cursor: pointer;
                    }
                }
            }
        }
    }
    .application-place {
        width: 100%;
        background: #fff;
        border-bottom-left-radius: 3px;
        border-bottom-right-radius: 3px;
        .place-list {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            img {
                width: auto;
                height: 210px;
            }
        }
    }
    .process-move {
        width: 100%;
        height: 767px;
        background: url(/photo/icon/巡逻流程.gif) no-repeat center;
    }
}
</style>
